function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 111.18 173.66"
}, props), React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  strokeWidth: "4",
  d: "M57.28 2.16c5.36 4.54 32.65 32.05 30.91 91.16a60.85 60.85 0 0 1-34.85 11.47s3 0 0 0c-17-.27-31.28-11.47-31.28-11.47C20.32 34.21 50.37 6.7 55.72 2.16c0 0 1.14-.36 1.56 0z"
}), React.createElement("circle", {
  cx: "56.65",
  cy: "53.14",
  r: "15.31",
  strokeWidth: "4.21",
  transform: "rotate(-88.8 56.86 53.12)"
}), React.createElement("path", {
  strokeWidth: "4.21",
  d: "M23.83 79.17s29.85 18.63 63.62 0m-53.76 28.56l-13.53 26.79L51 122.28l5.87 19.9a.45.45 0 0 0 .77 0l5.86-19.9 30.9 12.24-13.52-26.79M17 55.44s-9 21.23-3.25 41.71c-2.11 6.22-6.89 7.65-6.89 7.65S-9 73 17 55.44zm77.14 0s9 21.23 3.25 41.71c2.1 6.22 6.89 7.65 6.89 7.65S120.16 73 94.14 55.44zm-52.06 93.79l-8.7 17.26 19.88-7.89L57 171.41a.28.28 0 0 0 .49 0l3.78-12.81 19.88 7.89-8.71-17.26"
}))));